"use client";

import type { InputProps } from "../raw/Input";
import { Input } from "../raw/Input";
import { useField } from "formik";

export default function FormikInput({ onChange, ...props }: InputProps) {
  const [field, meta] = useField(props.name!);
  return (
    <Input
      {...field}
      // meta.touched so that it only show errors on the field we're on,
      // not all fields from the form
      error={meta.touched && meta.error}
      {...props}
    />
  );
}
